export default __webpack_public_path__ + "static/media/refresh.9a571eb8.svg";